import React from "react";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

const Botones=()=>{

    let history = useHistory();

    const BotonCrearPerfil = () =>{

       const onClickBtnCrearPerfil = () =>{
            history.push("/perfil/crear");
        }
        return(
            <Button
            type="primary"
            icon={<PlusOutlined/>}
            onClick={onClickBtnCrearPerfil}            
            >
                Crear Perfil
            </Button>
        )

    }
    return(
        <React.Fragment>
            <BotonCrearPerfil/>
        </React.Fragment>
    )

}
export default Botones;